(function () {
	'use strict';

	angular.module('widgets.initiative')
		.service('inventoryActionsStatusService', inventoryActionsStatusService);

	function inventoryActionsStatusService($http, URLS) {
		return {
			getInventoryActionsStatusData: getInventoryActionsStatusData
		};

		function getInventoryActionsStatusData(filterService, mode, ignoreFilters) {
			var url = String.format(URLS.host + URLS.inventoryActionStatus,
				filterService.getFactoryList());

			var filterQueryParams = filterService.getQueryParamsObject(true);
			filterQueryParams['dataType'] = mode;

			if (ignoreFilters) {
				filterQueryParams = _.omit(filterQueryParams, ignoreFilters);
			}

			url = addQueryParam(url,
				filterService.getFactoryList(), filterQueryParams, false);

			return $http.get(url)
				.then(getInventoryActionsStatusDataComplete)
				.catch(getInventoryActionsStatusDataFailed);

			function getInventoryActionsStatusDataComplete(response) {
				if (response && response.data){
					return response.data;
				}
				return [];
			}
			function getInventoryActionsStatusDataFailed(error) {
				return error;
			}
		}
	}
})();
